import { trimCharacter } from 'Lib/String';

/**
 * Retrieve a value at any depth in an object using a (dot seperated string) as a path.
 * @param {any} target An object to traverse to find a specific value at any object depth.
 * @param {string} path The path used to traverse and find the desired value in targetObject.
 */
export const get = <TSelected = any>(target: any, path: any): TSelected | null | undefined => {
  let pathArr = pathAsArray(path) as any;

  // use reduce to recursively find the next child object and return it.
  // if the path is invalid it will return undefined.
  return pathArr.reduce((child: any, nextPath: any) => child?.[nextPath], target) as TSelected;
};

// TODO: flesh this out to use types and tell us if a part is an array, array child?, whatever is useful.
type ObjectPath = string[];
export const parse = (path: string): ObjectPath => pathAsArray(path);

export const toString = (path: ObjectPath): string => pathAsString(path);

/**
 * @deprecated Rewrite using proper types, object parsing, and toString like the parse method above.
 */
export const pathAsArray = (path: string[] | string | number): string[] => {
  if (Array.isArray(path)) return path;

  if (typeof path === 'number') path = `${path}`; // play nice
  if (typeof path === 'string')
    return (
      path
        // convert array notation [] into paths
        .replace(/\[/gim, namePartSeparator)
        .replace(/\]/gim, '')
        // then convert path string to array of path parts.
        .split(namePartSeparator)
        .filter((part) => part !== '')
    );

  throw new Error(
    `Attempted to use an object path of an unknown type. Check how you are using object paths. Path was "${path}".`
  );
};

/**
 * @deprecated Rewrite using proper types, object parsing, and toString like the parse method above.
 */
export const pathAsString = (path: string[] | string | number) => {
  if (typeof path === 'string') return path;
  if (typeof path === 'number') return `${path}`;
  if (Array.isArray(path)) return joinPaths(...path);

  throw new Error(
    `Attempted to use an object path of an unknown type. Check how you are using object paths. Path was "${path}".`
  );
};

const namePartSeparator = '.';

export const joinPaths = (...pathStrings: Array<string | undefined>) => {
  return pathStrings
    .filter((arg) => !!arg)
    .map((n) => trimCharacter(n as string, namePartSeparator))
    .join(namePartSeparator);
};
